import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notices"
export default class extends Controller {
  static targets = ["notice"]
  static values = { 
    delay: { type: Number, default: 3000 },
    stagger: { type: Number, default: 1000 }
  }

  connect() {
    this.initializeNotices()
  }

  initializeNotices() {
    // Get ALL notices and count how many are already initialized
    const allNotices = this.noticeTargets
    const uninitializedNotices = allNotices.filter(notice => !notice.hasAttribute('data-initialized'))
    const initializedCount = allNotices.length - uninitializedNotices.length

    // Auto-dismiss notices after delay, staggered by stagger value
    uninitializedNotices.forEach((notice, index) => {
      // Mark as initialized to prevent duplicate timers
      notice.setAttribute('data-initialized', 'true')
      
      // Calculate delay based on total position in the stack, not just uninitialized index
      const totalIndex = initializedCount + index
      const delay = this.delayValue + (totalIndex * this.staggerValue)
      
      setTimeout(() => {
        this.dismissNotice(notice)
      }, delay)
    })
  }

  dismissNotice(notice) {
    // Check if notice still exists and hasn't been manually dismissed
    if (notice.parentElement) {
      // Add fade-out animation
      notice.style.opacity = '0'
      notice.style.transform = 'translateX(100%)'
      
      // Remove element after animation completes
      setTimeout(() => {
        if (notice.parentElement) {
          notice.remove()
        }
      }, 500) // Match the CSS transition duration
    }
  }

  // Action for manual dismiss button
  dismiss(event) {
    const notice = event.currentTarget.closest('[data-notices-target="notice"]')
    if (notice) {
      this.dismissNotice(notice)
    }
  }
}
